import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import 'react-router-dom';
import { UnauthPageLayout } from 'quanta-ui';
import { a as ConfigContext } from './ConfigProvider-9522944e.js';
import '@fortawesome/react-fontawesome';
import '@fortawesome/free-solid-svg-icons';

var headerBrand = function headerBrand(branding) {
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row items-center w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "quanta-brand"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "logo",
    src: branding.logo.small,
    className: "h-10 items-center mt-0 mr-2 justify-center md:justify-start",
    loading: "lazy"
  })));
};

function UnauthLayout(_ref) {
  var nav = _ref.nav,
      title = _ref.title,
      subtitle = _ref.subtitle,
      children = _ref.children;

  var _useContext = useContext(ConfigContext),
      branding = _useContext.branding,
      menu = _useContext.menu;

  var PageHelmet = function PageHelmet() {
    return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, nav.reduce(function (a, b) {
      return "".concat(a, " | ").concat(b);
    })));
  };

  var header = {
    brand: function brand() {
      return headerBrand(branding);
    },
    actions: []
  };
  var footer = menu.footer;
  return /*#__PURE__*/React.createElement(UnauthPageLayout, {
    header: header,
    title: title,
    subtitle: subtitle,
    nav: nav,
    footer: footer
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageHelmet, null), children));
}

export { UnauthLayout as U };
